"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var Chart_1 = __importDefault(require("../Chart"));
var utils_1 = require("./utils");
var LineChartContext = react_2.default.createContext({
    addSeries: function () { return undefined; },
    removeSeries: function () { return undefined; },
});
var LineChartSeries = function (_a) {
    var name = _a.name, data = _a.data, markerSymbol = _a.markerSymbol, color = _a.color, yAxis = _a.yAxis, _b = _a.showDataLabel, showDataLabel = _b === void 0 ? false : _b;
    var _c = react_2.useContext(LineChartContext), addSeries = _c.addSeries, removeSeries = _c.removeSeries;
    react_2.useEffect(function () {
        addSeries(name, data, markerSymbol, color, yAxis, showDataLabel);
        return function () {
            removeSeries(name);
        };
    }, [name, data, markerSymbol, color, addSeries, removeSeries, yAxis, showDataLabel]);
    return null;
};
// LineChart
var LineChart = function (_a) {
    var children = _a.children, options = _a.options;
    var _b = react_2.useState({}), seriesMap = _b[0], setSeriesMap = _b[1];
    var theme = react_1.useTheme();
    var contextValue = react_2.useMemo(function () { return ({
        addSeries: function (name, data, markerSymbol, color, yAxis, showDataLabel) {
            setSeriesMap(function (prevSeriesMap) {
                var _a;
                return (__assign(__assign({}, prevSeriesMap), (_a = {}, _a[name] = { data: data, markerSymbol: markerSymbol, color: color, yAxis: yAxis, showDataLabel: showDataLabel }, _a)));
            });
        },
        removeSeries: function (name) {
            setSeriesMap(function (prevSeriesMap) {
                var nextSeriesMap = __assign({}, prevSeriesMap);
                delete nextSeriesMap[name];
                return nextSeriesMap;
            });
        },
    }); }, []);
    var optionsObj = react_2.useMemo(function () { return utils_1.buildOptions(seriesMap, theme, options); }, [seriesMap, theme, options]);
    return (react_1.jsx(LineChartContext.Provider, { value: contextValue },
        react_1.jsx(Chart_1.default, __assign({ options: __assign({}, optionsObj) }, options, { sharedTooltip: true })),
        children));
};
exports.default = Object.assign(LineChart, {
    Series: LineChartSeries,
});
